import { AdviceScreen } from 'app/features/blog/screens'
import {
  fetchArticlesQuery,
  fetchBlogHomeQuery,
} from 'app/features/blog/screens/advice-screen/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page(props: any) {
  return <AdviceScreen {...props} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async ({ req, res, query }) => {
    console.time('AdviceScreen.getServerSideProps')
    const user = req?.session?.user
    const draft = !!query?.preview

    const client = initializeApollo({
      token: user?.token,
      previewToken: query?.token as string,
    })

    console.timeLog('AdviceScreen.getServerSideProps', 'initializeApollo')

    await client.query({
      query: fetchBlogHomeQuery.query,
      variables: {
        draft,
      },
    })

    console.timeLog('AdviceScreen.getServerSideProps', 'fetchBlogHomeQuery')

    await client.query({
      query: fetchArticlesQuery.query,
      variables: fetchArticlesQuery.defaultVariables,
    })

    console.timeLog('AdviceScreen.getServerSideProps', 'fetchArticlesQuery')

    // add cache headers if not authenticated
    if (!user) {
      res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate')
    }

    console.timeEnd('AdviceScreen.getServerSideProps')

    return addApolloState(client, {
      props: {
        user: user || null,
        preview: draft,
      },
    })
  }
)
